import { call, put } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";
import { Result } from "@/main/models/common/resultResponse";
import { KeyValue } from "@/main/models/common";
import { saveDomainCompanyAnnouncers, saveDomainAnnouncements, saveStatusDomain, saveDomainWhoCanSee } from "./index";
import { announcementApi } from "@/main/api";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";
import { GetDomainAnnouncements, GetDomainCompanyAnnouncers, GetStatusDomain } from "./announcementTypes";

export function* getDomainAnnouncementsSaga(action: GetDomainAnnouncements) {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(
			announcementApi.getDomainAnnouncements,
			action.payload.guidCompany,
		);

		if (response.data.result) {
			yield put(saveDomainAnnouncements(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveDomainAnnouncements(null, true, resultError.messagesDataError));
		}
	}
}

export function* getStatusDomainSaga(action: GetStatusDomain) {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(
			announcementApi.getStatusDomain,
			action.payload.showExpired,
		);
		if (response.data.result) {
			yield put(saveStatusDomain(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);
			yield put(saveStatusDomain(null, true, resultError.messagesDataError));
		}
	}
}

export function* getDomainCompanyAnnouncersSaga(action: GetDomainCompanyAnnouncers) {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(
			announcementApi.getDomainCompanyAnnouncers,
			action.payload.request,
		);
		if (response.data.result) {
			yield put(saveDomainCompanyAnnouncers(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);
			yield put(saveDomainCompanyAnnouncers(null, true, resultError.messagesDataError));
		}
	}
}

export function* getDomainWhoCanSeeSaga() {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(announcementApi.getDomainWhoCanSee);
		if (response.data.result) {
			yield put(saveDomainWhoCanSee(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);
			yield put(saveDomainWhoCanSee(null, true, resultError.messagesDataError));
		}
	}
}
